
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import RecommdCard from '../RecommdCard/index.vue'
import { Observer } from 'mobx-vue'
import type { CityTypeInfo } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/cities'

@Observer
@Component({
  components: {
    NewSwiper,
    LazyImg,
    RecommdCard
  }
})
export default class HeaderPanel extends Vue {
  activeIndex: number = 0

  @Ref()
  swiper: {
    dotScrollTo: (index: number) => void
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get CityStore() {
    return this.$store.$tonghao.Cities
  }

  get HomeStore() {
    return this.$store.$homeV2.dataSource
  }

  handleToCityPage(cityId: number) {
    if (!cityId) return

    this.$router.push({
      path: `/topic/city/${cityId}`
    })
  }

  // 首个城市加入事件判断
  handleClick(data: CityTypeInfo) {
    if (!data) return

    const { status, recruitStatus } = data

    if (status === EnumCityStatus.Assistance) {
      this.$emit('show-assistance')
    } else if (recruitStatus === true) {
      this.$emit('show-recruit')
    } else if (status === EnumCityStatus.Inited) {
      this.$emit('show-join')
    }
  }

  handleChange(index: number): void {
    if (this.activeIndex === index) return

    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
